import { render } from "./categoryadmin.vue?vue&type=template&id=0dec6b87&scoped=true"
import script from "./categoryadmin.vue?vue&type=script&lang=js"
export * from "./categoryadmin.vue?vue&type=script&lang=js"

import "./categoryadmin.vue?vue&type=style&index=0&id=0dec6b87&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dec6b87"]])

export default __exports__